import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { createDepartment } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};
  
  const payload = {
    ...Object.fromEntries(
      Object.entries(values).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };

  if (payload.head?.id) {
    payload.head = { id: payload.head.id };
  }

  if (payload.coordinators) {
    payload.coordinators = payload.coordinators.map((coord) => ({
      coordinator: { id: coord.id },
    }));
  }

  return payload;
}

export function useCreateDepartment() {
  return useMutation({
    mutationFn: async ({ item }) => {
      const payload = buildPayload(item);
      const response = await createDepartment({ item: payload });
      return response;
    },
    onSuccess: () => {
      toast.success("Department Created Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
